import { Plane, ArrowRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { HEADER_COLOR, TA_STATUS, fmtTime, fmtMin } from './taUtils';

function Stat({ label, value, className = '', testid }) {
    return (
        <div className="min-w-[96px]">
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</p>
            <p className={`text-lg font-bold font-mono ${className}`} data-testid={testid}>{value}</p>
        </div>
    );
}

export function TurnaroundHeader({ view }) {
    const c = HEADER_COLOR[view.color] || HEADER_COLOR.green;
    const tz = view.timezone;
    const remaining = view.remaining_min;
    return (
        <div className={`rounded-xl border p-4 sm:p-5 ${c.ring}`} data-testid="ta-header">
            <div className="flex flex-wrap items-center gap-3 mb-4">
                <Plane className="w-5 h-5 text-primary" />
                <h2 className="text-2xl font-bold font-mono" data-testid="ta-flight-number">{view.flight_number}</h2>
                <span className="flex items-center gap-1 font-mono text-muted-foreground">{view.origin}<ArrowRight className="w-3 h-3" />{view.destination}</span>
                <Badge variant="outline" className="font-mono">{view.aircraft_registration || 'Sin aeronave'}</Badge>
                <Badge variant="outline" data-testid="ta-status">{TA_STATUS[view.status]}</Badge>
                <span className={`ml-auto text-sm font-semibold ${c.text}`} data-testid="ta-color-label">{c.label}</span>
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-3">
                <Stat label={view.arrived ? 'Llegada (calzos)' : 'Llegada prevista'} value={fmtTime(view.anchor_time, tz)} testid="ta-arrival" />
                <Stat label="Salida prevista" value={fmtTime(view.scheduled_departure, tz)} testid="ta-departure" />
                <Stat label="Tiempo estándar" value={fmtMin(view.standard_minutes)} testid="ta-standard" />
                <Stat label="Planificado" value={fmtMin(view.planned_total_min)} testid="ta-planned" />
                <Stat label="Proyectado" value={fmtMin(view.projected_total_min)} className={view.projected_total_min > view.standard_minutes ? 'text-red-700 dark:text-red-400' : ''} testid="ta-projected" />
                <Stat label={view.status === 'completado' ? 'Tiempo real' : 'Real en curso'} value={fmtMin(view.elapsed_min)} className={c.text} testid="ta-elapsed" />
                <Stat label={remaining !== null && remaining !== undefined && remaining < 0 ? 'Exceso' : 'Restante'} value={remaining === null || remaining === undefined ? '—' : remaining < 0 ? `+${Math.round(-remaining)} min` : `${Math.round(remaining)} min`} className={remaining < 0 ? 'text-red-700 dark:text-red-400' : c.text} testid="ta-remaining" />
            </div>
        </div>
    );
}
